var deepDiffMapper = {
    VALUE_CREATED: 'created',
    VALUE_UPDATED: 'updated',
    VALUE_DELETED: 'deleted',
    VALUE_UNCHANGED: 'unchanged',
    map: function(obj1, obj2) {
        if (this.isFunction(obj1) || this.isFunction(obj2)) {
            throw 'Invalid argument. Function given, object expected.';
        }
        if (this.isValue(obj1) || this.isValue(obj2)) {
            let res_type = this.compareValues(obj1, obj2);
            if(res_type == this.VALUE_UNCHANGED){
                return null;
            }else{
                return {
                    type: res_type,
                    data: obj1 === undefined ? obj2 : obj1
                };
            }
        }

        // Arrays are matched by a stable element key (id/idA) so that inserting,
        // removing or reordering a single item is not reported as a change to the
        // whole tail. Falls back to positional comparison when items have no key.
        if (this.isArray(obj1) || this.isArray(obj2)) {
            return this.mapArray(obj1 || [], obj2 || []);
        }

        var diff = {};
        for (let key in obj1) {
            if (this.isFunction(obj1[key])) {
                continue;
            }

            var value2 = undefined;
            if (obj2[key] !== undefined) {
                value2 = obj2[key];
            }

            diff[key] = this.map(obj1[key], value2);
        }
        for (let key in obj2) {
            if (this.isFunction(obj2[key]) || diff[key] !== undefined) {
                continue;
            }

            diff[key] = this.map(undefined, obj2[key]);
        }

        return diff;

    },
    mapArray: function (arr1, arr2) {
        var result = {};
        if (this.hasStableKeys(arr1) && this.hasStableKeys(arr2)) {
            var byKey1 = this.indexByKey(arr1);
            var byKey2 = this.indexByKey(arr2);
            var keys = {};
            for (let k in byKey1) { keys[k] = true; }
            for (let k in byKey2) { keys[k] = true; }
            for (let k in keys) {
                result[k] = this.map(byKey1[k], byKey2[k]);
            }
        } else {
            var len = Math.max(arr1.length, arr2.length);
            for (var i = 0; i < len; i++) {
                result[i] = this.map(arr1[i], arr2[i]);
            }
        }
        return result;
    },
    getKey: function (item) {
        if (!this.isObject(item)) { return undefined; }
        if (item.id !== undefined && item.id !== null) { return String(item.id); }
        if (item.idA !== undefined && item.idA !== null) { return String(item.idA); }
        return undefined;
    },
    hasStableKeys: function (arr) {
        if (arr.length === 0) { return true; }
        return arr.every((item) => this.getKey(item) !== undefined);
    },
    indexByKey: function (arr) {
        var out = {};
        for (let item of arr) { out[this.getKey(item)] = item; }
        return out;
    },
    // Walks a diff tree and returns true if any leaf represents an actual change.
    hasChanges: function (node) {
        if (node === null || node === undefined) { return false; }
        if (typeof node.type === 'string' && Object.prototype.hasOwnProperty.call(node, 'data')) {
            return node.type !== this.VALUE_UNCHANGED;
        }
        for (let key in node) {
            if (this.hasChanges(node[key])) { return true; }
        }
        return false;
    },
    compareValues: function (value1, value2) {
        if (value1 === value2) {
            return this.VALUE_UNCHANGED;
        }
        if (this.isDate(value1) && this.isDate(value2) && value1.getTime() === value2.getTime()) {
            return this.VALUE_UNCHANGED;
        }
        if (value1 === undefined) {
            return this.VALUE_CREATED;
        }
        if (value2 === undefined) {
            return this.VALUE_DELETED;
        }

        return this.VALUE_UPDATED;
    },
    isFunction: function (x) {
        return Object.prototype.toString.call(x) === '[object Function]';
    },
    isArray: function (x) {
        return Object.prototype.toString.call(x) === '[object Array]';
    },
    isDate: function (x) {
        return Object.prototype.toString.call(x) === '[object Date]';
    },
    isObject: function (x) {
        return Object.prototype.toString.call(x) === '[object Object]';
    },
    isValue: function (x) {
        return !this.isObject(x) && !this.isArray(x);
    }
}
module.exports= deepDiffMapper;
